import { authRoutes } from "./auth"
import { userRoutes } from "./user"
import { dashboardRoutes } from "./dashboard"
import { campaignsRoutes } from "./campaigns"
import { mediaRoutes } from "./media"
import { companiesRoutes } from "./companies"
import { screensRoutes } from "./screens"
import { designSystemRoutes } from "./designSystem"
import { checkoutRoutes } from "./checkout"
import NotFound from "@/pages/NotFound.vue"
import Forbidden from "@/pages/Forbidden.vue"

export default [
	...designSystemRoutes,
	...campaignsRoutes,
	...authRoutes,
	...userRoutes,
	...mediaRoutes,
	...companiesRoutes,
	...screensRoutes,
	...dashboardRoutes,
	...checkoutRoutes,
	{ path: '/forbidden', name: 'forbidden', component: Forbidden, meta: { authRequired: true } },
	{ path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
]
